import AllRoutes from "./routes";
import './App.css'
import "./style/font.css";
import useUserLocation from "./hooks/useUserLocation";
import "./style/table.css";
import "./style/calendar.css";
import '../src/components/common-components/form-input.css';
import './i18n'
import { createContext, useEffect, useState } from "react";
import { environment } from "./env/environment";
import useReduxStore from "./hooks/useReduxStore";
import { UNREADCOUNT } from "./repository/notificationRepo";
import useDynamicFavicon from "./hooks/useDynamicFavicon";
import { useLocation } from "react-router-dom";
export const CratCount = createContext()

function App() {
  const [counts, setCounts] = useState({
    cartCount: 0,
    NotificationCount: 0,
  })
  useUserLocation();
  useDynamicFavicon()
  const { selector: user } = useReduxStore("auth")
  const clientId = user?.client_id ?? undefined
  const { pathname } = useLocation()
  const getNotificationList = async () => {
    const payload = {
      user_id: clientId
    };
    try {
      let response = await UNREADCOUNT(payload)
      setCounts((prev) => ({
        ...prev,
        NotificationCount: response?.unreadedCount,
      }));
    } catch (error) {
      setCounts((prev) => ({
        ...prev,
        NotificationCount: 0,
      }));
    }
  }
  useEffect(() => {
    let ws;
    let reconnectInterval;

    const connectWebSocket = () => {
      ws = new WebSocket(`${environment?.SocketUrl}/?type=client&userId=${clientId}`);

      ws.onopen = () => {
        ws.send(JSON.stringify({
          event: "get-cart-count",
          userId: clientId,
        }));
      };

      ws.onmessage = (data) => {
        try {
          const details = JSON.parse(data?.data);
          if (details.event === "cart-count") {
            setCounts((prev) => ({
              ...prev,
              cartCount: details?.data?.cartCount,
            }));
          }
          if (details?.event === "notification") {
            getNotificationList()
          }
          if (details.event === "payment-received" && pathname !== "/payment-successfull") {
            window.location.reload();
          }
        } catch (err) {

        }
      };

      ws.onerror = (err) => {
        attemptReconnect();
      };

      ws.onclose = () => {
        attemptReconnect();
      };
    };

    const attemptReconnect = () => {
      clearInterval(reconnectInterval);
      reconnectInterval = setInterval(() => {
        if (ws?.readyState === WebSocket.CLOSED && clientId) {
          connectWebSocket();
        }
      }, 5000);
    };

    if (clientId) {
      connectWebSocket();
    }
    getNotificationList()
    return () => {
      if (ws) {
        ws.close();
      }
      clearInterval(reconnectInterval);
    };
  }, [clientId]);



  return (
    <CratCount.Provider value={{ setCounts, counts }}>
      <AllRoutes />
    </CratCount.Provider>
  );
}
export default App;
